import React from 'react';
import { isMobile } from '@/biz/tool';
import WebModal from './Modal';
import BottomDrawer from './BottomDrawer';
import { useTranslation } from 'react-i18next';
import { useNavStore } from '@/hooks/useNavStore';
import { usePlatformStore } from '@/hooks/usePlatformStore';

const ModalCreditScore: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { showModalCreditScore, setShowModalCreditScore } = useNavStore();
  const { user } = usePlatformStore();

  const CreditScoreContent = () => {
    return (
      <div className="flex flex-col gap-y-6 mt-2">
        <div className="self-stretch justify-start text-[#57534D] text-sm font-normal leading-relaxed">
          {t('modal_credit_score.modal_content', {
            defaultValue:
              'A higher score means more consistent and trustworthy performance. It serves as both your trust badge for brands and an important factor in platform recommendations.'
          })}
        </div>
        <div className="relative flex justify-center items-center">
          <img
            className="w-[137px] h-[90px]"
            src="/MaskGroup.png"
            alt="CreditScore"
          />
          <div className="absolute mt-[-10px] inset-0 flex justify-center items-center">
            <span className="text-neutral-800 text-4xl font-semibold font-['Baloo_2'] uppercase leading-9">
              {user?.displayCreditScore}
            </span>
          </div>
        </div>
        <div className="flex justify-center">
          <div className="w-[340px] text-center justify-start text-[#57534D] text-sm font-normal font-['DM_Sans'] leading-snug">
            {t('modal_credit_score.modal_note', {
              defaultValue:
                'The Credit Score (max 5.0) reflects how reliable you are in delivering tasks on time.'
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/*  信用分信息展示弹窗 */}
      {isMobile() ? (
        <BottomDrawer
          title={t('modal_credit_score.modal_title', {
            defaultValue: 'Credit score'
          })}
          visible={showModalCreditScore}
          handleClose={() => setShowModalCreditScore(false)}
          isShowFooter={false}
        >
          <CreditScoreContent />
        </BottomDrawer>
      ) : (
        <WebModal
          title={t('modal_credit_score.modal_title', {
            defaultValue: 'Credit score'
          })}
          visible={showModalCreditScore}
          handleClose={() => setShowModalCreditScore(false)}
          width={500}
          isShowFooter={false}
        >
          <CreditScoreContent />
        </WebModal>
      )}
    </>
  );
};

export default ModalCreditScore;
